import { FormattedMessage } from 'react-intl';
import Coupon from '@alltrails/core/types/Coupon';

const getFreeTrialDurationHeading = (coupon: Coupon, couponSubscriptionTier: Coupon['subscriptionTier']) => {
  const couponTrialDuration = coupon.freeTrialDuration;
  if (couponTrialDuration) {
    const durationData = couponTrialDuration.split(' ');
    const durationNum = Number(durationData[0]);
    const durationType = durationData[1];

    if (couponSubscriptionTier === 'any') {
      if (durationType.includes('month')) {
        return (
          <FormattedMessage
            defaultMessage="Your first {durationNum, plural, one {month’s} other {{durationNum} months are}} on us"
            values={{ durationNum }}
          />
        );
      }

      if (durationType.includes('week')) {
        return (
          <FormattedMessage
            defaultMessage="Your first {durationNum, plural, one {week’s} other {{durationNum} weeks are}} on us"
            values={{ durationNum }}
          />
        );
      }

      if (durationType.includes('day')) {
        return (
          <FormattedMessage
            defaultMessage="Your first {durationNum, plural, one {day’s} other {{durationNum} days are}} on us"
            values={{ durationNum }}
          />
        );
      }
    }

    const tierValue = couponSubscriptionTier === 'peak' ? 'Peak' : 'Plus'; // tiers remain untranslated

    if (durationType.includes('month')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first month of {tierValue} is on us" values={{ tierValue }} />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} months of {tierValue} are on us" values={{ durationNum, tierValue }} />;
      }
    }

    if (durationType.includes('week')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first week of {tierValue} is on us" values={{ tierValue }} />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} weeks of {tierValue} are on us" values={{ durationNum, tierValue }} />;
      }
    }

    if (durationType.includes('day')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first day of {tierValue} is on us" values={{ tierValue }} />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} days of {tierValue} are on us" values={{ durationNum, tierValue }} />;
      }
    }
  }

  return <FormattedMessage defaultMessage="Elevate your adventure" />;
};

export default getFreeTrialDurationHeading;
